module.exports = __webpack_public_path__ + "img/LINDSAY CHERRY, IN HOGE HOUSE, 1956 .cacfbbb3.jpg";